<template>
	<div :class="darkMode ? 'dark' : ''">
      	<!-- Messaggio che appare se si accede da mobile e schermi md -->
		<div id="onlydesktop" class="block md:!hidden"> 
			<div v-if="loggedAs && loggedAs.ruolo=='admin'" id="onlydesktopAdmin" class=" bg-csenRed-200 p-12">
				<div class="bg-csenRed-100 text-csenRed-600 p-3 inline-flex rounded-full mb-4">
					<MobileIcon></MobileIcon>
				</div>
				<div class="bg-csenGreen-100 text-csenGreen-600 p-3 inline-flex rounded-full mb-4">
					<DesktopIcon></DesktopIcon>
				</div>
				<div><h2 class="text-left text-lg text-csenRed-800 font-bold mb-2">⛔ Accesso non consentito</h2></div>
				<p class=" text-left text-csenRed-900 text-base font-semibold">L'accesso come amministratore <strong>non è consentito da mobile</strong>. Collegati da un computer desktop per svolgere le attività come amministratore.</p> 

			</div>
		</div>


		<div id="maincontainer" class="hidden md:!block sm:px-[5%] !font-sans bg-white dark:bg-[#171a35]">
			<div class="bg-csenBlue-950 dark:bg-csenBlue-900 px-12 sm:px-24 py-12 rounded-b-md">
				<MenuTecnici @avvia-guida="avviaTour"></MenuTecnici>
				<div flat class="mt-6 bg-white dark:!bg-white px-6 py-3 rounded-md">
				<v-text-field
					v-model="search"
					hide-details
					flat 
					solo
					light
					class="relative w-full border-none rounded-lg "
					prepend-icon="mdi-magnify"
					clearable
					placeholder="Cerca corso"
					clear-icon="mdi-close-circle-outline"
					@click:clear="search = null"
				></v-text-field>
				</div>
			</div>
		<div>

		<div class="flex justify-end mt-3 mb-0 py-2 rounded-md gap-x-2">
			<v-btn id="aggiungi-corso" @click="openCorsoDialog()" class="!bg-csenBlue-900 dark:!bg-csenBlue-700 !text-white !tracking-normal !py-6">
				<PlusIcon class="text-csenBlue-300 mr-2"></PlusIcon>
				<span>Nuovo corso</span>
			</v-btn>
		</div>
	
		<div id="tabella" class="py-3">

			<v-data-table id="tabella-corsi" class="tabella-csen" :headers="headers" :items="corsi" :loading="isLoading" :search="search" :footer-props="{itemsPerPageText: 'Corsi per pagina'}">
				<template v-slot:item.nome="{ item }"> <span class="!font-semibold dark:!text-csenBlue-200">{{ item.nome }}</span></template>	
				<template v-slot:item.azioni="{ item }">
				<div class="d-flex justify-end gap-1">
					<v-btn v-if="item.edizioni_corsi.length > 0" id="edizioni-tabella-corsi"
						class="!bg-violet-100 !text-violet-600 !tracking-normal dark:!text-white dark:!bg-violet-500 !px-3"
						@click="mostraEdizioniDialog(item)"
					>
						<HistoryIcon class="!h-5 !w-5"></HistoryIcon>
						<span class="ml-2">Edizioni <span class="font-bold">({{ item.edizioni_corsi.length }})</span></span>
					</v-btn>
					<v-btn v-else id="edizioni-tabella-corsi"
						class="!bg-gray-100 dark:!bg-violet-500/20 !text-gray-600 dark:!text-white !tracking-normal !px-3"
						@click="mostraEdizioniDialog(item)"
					>
					<HistoryIcon class="!h-5 !w-5"></HistoryIcon>
					<span class="ml-2">Edizioni <span class="font-bold">({{ item.edizioni_corsi.length }})</span></span>
					</v-btn>  
					<button
						id="modifica-corso"
						type="button"
						@click="openCorsoDialog(item)" 
						class="bg-csenOrange-100 !text-csenOrange-500 dark:bg-csenOrange-500 dark:!text-white inline-flex justify-center content-center px-auto rounded-md hover:bg-csenOrange-500 hover:dark:brightness-125 hover:!text-white transition w-9 h-9" 
						title="Modifica Corso"
					>
						<EditIcon class="my-auto"></EditIcon>
					</button>
					<button
						id="elimina-corso"
						type="button"
						class="bg-red-100 dark:bg-csenRed-500 !text-csenRed-500 dark:!text-white inline-flex justify-center content-center px-auto rounded-md hover:bg-csenRed-500 hover:dark:brightness-125 hover:!text-white transition w-9 h-9" 
						title="Elimina Corso"
						@click="eliminaCorso(item.id)"
					>
						<DeleteIcon class="my-auto"></DeleteIcon>
					</button>
				</div>
				</template>
			</v-data-table>
			</div>
			<!-- DIALOG AGGIUNGI / MODIFICA CORSO  -->
			<template >
			<v-dialog v-model="isDialogCorsoOpen" width="600px" persistent>
				<v-card plain class="dark:!bg-csenBlue-800">
					<v-card-title class="font-bold text-2xl py-6 pl-8 dark:!bg-csenBlue-800">
						<span class="flex-grow">
							<h2 class="dark:!text-white">
								Aggiungi / Modifica corso
							</h2>
						</span>
						<v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="closeCorsoDialog()">
							<CloseIcon />
						</v-btn>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="!m-0 !p-0">
						<div class="my-5 mx-8 ">
							<v-form v-model="validFormCorso" ref="formCorso">
								<!-- IMPOSTA NOME CORSO -->
								<v-text-field
									v-model="corsoInModifica.nome"
									label="Nome corso"
									outlined
									:rules="[rules.required]"
									@input="corsoModificato = true"
								></v-text-field>
								<!-- IMPOSTA CATEGORIA -->
								<v-autocomplete
									v-model="corsoInModifica.categoria_corso_id"
									autocomplete="none"
									:items="categorieCorsi"
									label="Categoria"
									item-text="nome"
									item-value="id"
									outlined
									:rules="[rules.required]"
									@change="corsoModificato = true"
								></v-autocomplete>
								<!-- IMPOSTA NOTE -->
								<v-textarea
									v-model="corsoInModifica.note"
									label="Note"
									outlined
									@input="corsoModificato = true"
								></v-textarea>
							</v-form>
						</div>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="p-4 justify-end bg-white dark:!bg-csenBlue-800">
						<v-btn class="!bg-white!tracking-wider !py-5 !px-5" text @click="closeCorsoDialog()">Annulla</v-btn>
						<v-btn class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5" text @click="aggiungiModificaCorso()">Salva modifiche</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			</template>

			<!-- DIALOG PANNELLO EDIZIONI-->
			<template>
				<v-dialog v-model="isDialogEdizioniOpen" max-width="1200px" persistent>
				<!-- @click:outside="closeEdizioniDialog()" -->
				<v-card plain class="dark:!bg-csenBlue-950">
					<v-card-title class="dark:!bg-csenBlue-800">
					Edizioni del corso: <span class="font-bold text-csenBlue-900 dark:text-csenBlue-200 ml-1">
						{{ edizioniCorsoNomeSelezionato }}</span>
					<v-spacer></v-spacer>
					<v-btn icon @click="closeEdizioniDialog()">
						<CloseIcon />
					</v-btn>
					</v-card-title>
					<v-divider ></v-divider>
					<v-card-text>
						<div class="flex justify-end my-5 rounded-md">
							<v-btn @click="openSingolaEdizioneDialog()" class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-3">
								<PlusIcon class="text-csenBlue-300 mr-2"></PlusIcon>
								<span>Nuova Edizione</span>
							</v-btn>
						</div>
						<v-data-table
							:headers="modalHeaders"
							:items="edizioniCorso"
							:loading="isLoadingEdizioni"
							:footer-props="{
								itemsPerPageText: 'Edizioni per pagina'
							}"
							class="mt-3 !font-sans"
						>					
							<template v-slot:item.scadenza_iscrizione="{ item }">
								{{ formattaData(item.scadenza_iscrizione) }}
							</template>

							<template v-slot:item.kajabi_tag="{ item }">
								<span class="bg-violet-100 text-violet-600 dark:text-white dark:bg-violet-600 font-medium py-1 px-2 rounded-md">{{ item.kajabi_tag }}</span>
							</template>

							

							<template v-slot:item.azioni="{ item }">
								<div class="d-flex justify-end gap-1">
									<button
										type="button"
										class="bg-csenOrange-100 !text-csenOrange-500 dark:bg-csenOrange-500 dark:!text-white inline-flex justify-center content-center px-auto rounded-md hover:bg-csenOrange-500 hover:dark:!brightness-125 hover:!text-white transition w-9 h-9" 
										title="Modifica Edizione"
										@click="openSingolaEdizioneDialog(item)"
									>
										<EditIcon class="my-auto"></EditIcon>
									</button>
									<button
										type="button"
										class="bg-red-100 !text-csenRed-500 dark:bg-csenRed-500 dark:!text-white inline-flex justify-center content-center px-auto rounded-md hover:bg-csenRed-500 hover:!text-white hover:dark:!brightness-125 transition w-9 h-9" 
										title="Elimina Edizione"
										@click="eliminaEdizione(item)"
									>
										<DeleteIcon class="my-auto"></DeleteIcon>
									</button>
								</div>
							</template>
						</v-data-table>
					</v-card-text>
				</v-card>

				</v-dialog>
			</template>

			<!-- DIALOG AGGIUNGI / MODIFICA EDIZIONE  -->
			<template>
			<v-dialog v-model="isDialogSingolaEdizioneOpen" width="600px" persistent>
				<v-card plain class="dark:!bg-csenBlue-800">
					<v-card-title class="font-bold text-2xl py-6 pl-8">
						<span class="flex-grow">
						<h2>
							Aggiungi / Modifica Edizione corso
						</h2>
						</span>
						<v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="closeSingolaEdizioneDialog()">
						<CloseIcon />
						</v-btn>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="!m-0 !p-0">
						<div class="my-5 mx-8">

							<v-form v-model="validFormEdizione" ref="formEdizione">
								<!-- IMPOSTA NOME CORSO -->						
								<v-text-field
									v-model="edizioneInModifica.nome"
									label="Nome edizione"
									outlined
									:rules="[rules.required]"
									@input="edizioneModificata = true"
								></v-text-field>

								<!-- IMPOSTA KAJABI TAG -->
								<v-text-field
									v-model="edizioneInModifica.kajabi_tag"
									label="Kajabi Tag"
									outlined
									:rules="[rules.required]"
									@input="edizioneModificata = true"
								></v-text-field>

								<!-- IMPOSTA PREZZO -->
								<v-text-field
									v-model="edizioneInModifica.prezzo"
									label="Prezzo in €"
									outlined
									type="number"
									min="0"
									step="0.01"
									:rules="[rules.required]"
									@input="edizioneModificata = true"
								></v-text-field>
								<!-- Il seguente non funziona: -->
								<!-- @input="e => prezzo = parseFloat(e.target.value).toFixed(2)" -->

								<!-- IMPOSTA DATA DI SCADENZA CORSO -->
								<v-text-field
									v-model="edizioneInModifica.scadenza_iscrizione"
									label="Data di scadenza iscrizione"
									outlined
									type="date"
									:rules="[rules.required]"
									@input="edizioneModificata = true"
								></v-text-field>

								<!-- IMPOSTA STATO -->
								<v-select
									v-model="edizioneInModifica.stato"
									:items="statiEdizioneOptions"
									label="Stato"
									outlined
									:rules="[rules.required]"
									@change="edizioneModificata = true"
								></v-select>
							</v-form>
						</div>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="p-4 justify-end bg-white dark:!bg-csenBlue-800">
						<v-btn class="!bg-white!tracking-wider !py-5 !px-5" text @click="closeSingolaEdizioneDialog()">Annulla</v-btn>
						<v-btn class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5" text @click="aggiungiModificaEdizione()">Salva modifiche</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			</template>
		</div>


		<!-- LOGOUT -->
		<div class="block sm:flex gap-2 !justify-start border-t border-t-gray-300 dark:border-t-csenBlue-300 pt-4 mt-3">
		  <template>
			 <v-btn v-if="loggedAs && loggedAs.ruolo && loggedAs.ruolo.length > 0" class=" !block !mb-2 sm:!inline sm:!mb-0 !tracking-normal !bg-slate-200 !text-slate-600 dark:!text-white dark:!bg-csenBlue-800" @click="logout">
				<v-icon left>mdi-logout</v-icon>
				Logout
			 </v-btn>
		  </template>
	   </div>

		  <!-- TO TOP -->
		  <div 
               class="flex fixed justify-end items-end bottom-6 md:bottom-5 right-6 md:right-5 bg-csenBlue-800 rounded-full px-2 py-2 !z-[60] cursor-pointer hover:bg-csenOrange-500 transition" 
               @click="scrollToTop"
			   title="Torna in cima"
            ><div><ChevronUpIcon></ChevronUpIcon></div>
            </div>
			<!-- FOOTER -->
				<div> 
					<FooterComponent></FooterComponent>
				</div>
			<!-- FINE FOOTER -->

		</div>

		<v-tour name="myTourCorsi" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks"></v-tour>

		<!-- Overlay per bloccare i click durante il tour -->
		<div v-if="tourAvviato" class="tour-overlay"></div>
	</div>
  </template>
  

<script>
  import EditIcon from '../components/icons/EditIcon.vue';
  import DeleteIcon from '../components/icons/DeleteIcon.vue';
  import CloseIcon from '../components/icons/CloseIcon.vue';
  import HistoryIcon from '../components/icons/HistoryIcon.vue';
  import MenuTecnici from '../components/MenuTecnici.vue';
  
  import mixin from '../mixin';
  import store from '../store';

  export default {
    components: {
      MenuTecnici, EditIcon, DeleteIcon, HistoryIcon, CloseIcon,
    },
	mixins: [mixin],
    data() {
      return {
		validFormCorso: false,
		validFormEdizione: false,

		isLoading: false,
		isLoadingEdizioni: false,
		
		// Nota: il plurale indica il dialog con la tabella delle edizioni, il singolare la modifica della singola edizione:
        isDialogEdizioniOpen: false,
        isDialogSingolaEdizioneOpen: false,

		isDialogCorsoOpen: false,
		search: null,

		corsi: [],

		categorieCorsi: [],
		corsoInModifica:{
			id: null,
			nome: null,
			categoria_corso_id: null,
			note: null,
		},
		corsoModificato: false,

		statiEdizioneOptions: ['draft','online'],
		edizioneInModifica:{
			id: null,
			kajabi_tag: null,
			nome: null,
			prezzo: null,
			scadenza_iscrizione: null,
			stato: null,
		},
		edizioneModificata: false,

        // categorieCorsi: {},
        headers: [
          {text: 'Corso', value: 'nome'},
          {text: 'Numero di Tecnici', value: 'tecnici_count'},
          {text: 'Categoria', value: 'categoria_corso.nome'},
          {text: 'Note', value: 'note', width:'250px'},
          {text: 'Azioni', value: 'azioni', sortable:false, class: 'text-end'},
        ],
        modalHeaders: [
          { text: 'Nome edizione', value: 'nome' },
          { text: 'Kajabi tag', value: 'kajabi_tag' },
          { text: 'Numero di tecnici', value: 'tecnici_count' },
          { text: 'Data di scadenza iscrizione', value: 'scadenza_iscrizione' },
          { text: 'Azioni', value: 'azioni', sortable:false, class: 'text-end'}
        ],

		// Le seguenti sono le edizioni del corso selezionato
		edizioniCorso: [],
		// Il seguente è l'ID del corso per cui si stanno visualizzando le edizioni
		edizioniCorsoIdSelezionato: null,
		edizioniCorsoNomeSelezionato: null,

		tourAvviato: false,
		tourCallbacks: {
			onFinish: this.fineTour,
			onSkip: this.fineTour,
			onStop: this.fineTour,
		},
		tourSteps: [
			{
				target: '#menu-corsi-tab',
				content: `
					Benvenuto nella nella sezione Corsi!
				`,
			},
			{
				target: '#tabella-corsi',
				content: `
					Qui trovi la tabella con l'elenco di tutti i Corsi e i relativi dettagli in ogni riga.<br/><br/>
					Puoi cercare un corso scorrendo l'elenco o digitando il nome nella barra di ricerca in alto dove leggi “Cerca corso”
				`,
			},
			{
				target: '#edizioni-tabella-corsi',
				content: `
					Per ogni corso, con questo pulsante, puoi aggiungere, modificare o eliminare le relative edizioni.
				`,
			},
			{
				target: '#modifica-corso',
				content: `
					Cliccando sulla matita puoi modificare i dettagli del corso.
				`,
			},
			{
				target: '#elimina-corso',
				content: `
					Se invece vuoi eliminare un corso dall'elenco clicca sull'icona del cestino.<br/><br/>
					Ricorda che insieme al corso eliminerai tutte le sue edizioni!
				`,
			},
			{
				target: '#aggiungi-corso',
				content: `
					Se desideri aggiungere proprio un nuovo corso basta cliccare qui.<br/><br/>
					La guida di questa sezione è finita.<br/>
					Per continuare la guida vai nelle altre pagine del menu.<br/><br/>
					Saluti sportivi!
				`,
			},
		]
      }
    },
	created() {
		this.getCorsiEdizioniENumTecnici();

		this.getCategorieCorsi();
    },
	mounted(){
		if(!this.isGuidaCompleta('is_guida_corsi_completa')){
			this.tourAvviato = true;
			this.$tours['myTourCorsi'].start();
			this.setGuidaCompleta('is_guida_corsi_completa');
		}
	},
    methods: {
		avviaTour(){
			this.tourAvviato = true;
			this.$tours['myTourCorsi'].start();
		},
		fineTour(){
			console.log("dentro fine tour")
			this.tourAvviato = false;
		},
		getCorsiEdizioniENumTecnici(){
			this.isLoading = true;
			axios.get('/corsi_con_edizioni_e_tecnici')
			.then(response => {
				this.corsi = response.data;
			})
			.catch(error => {
				console.error('Errore nel recupero dei corsi:', error);
			})
			.finally(() => {
				this.isLoading = false;
			});
		},
	  // ================= Corso =================
	  getCategorieCorsi(){
		axios.get('/categorie_corsi')
			.then(response => {
				this.categorieCorsi = response.data;
			})
			.finally(() => {
			});
	  },
	  resetCorsoInModifica(){
			this.corsoInModifica.id = null;
			this.corsoInModifica.nome = null;
			this.corsoInModifica.categoria_corso_id = null;
			this.corsoInModifica.note = null;

			this.corsoModificato = false;

			try {
				this.$refs['formCorso'].resetValidation()
			} catch (error) {}
	  },
	  isCorsoValido(){
		if(this.$refs['formCorso'].validate())
			return true;
		
		return false;
	  },
	  openCorsoDialog(corso){
		if(corso){
			this.corsoInModifica.id = corso.id;
			this.corsoInModifica.nome = corso.nome;
			this.corsoInModifica.categoria_corso_id = corso.categoria_corso_id;
			this.corsoInModifica.note = corso.note;
		} else {
			this.resetCorsoInModifica();
		}

	  	this.isDialogCorsoOpen = true;
	  },
	  closeCorsoDialog(daConfermare = true){
		if(this.corsoModificato && daConfermare){
			store.commit('mostraDialogConferma', 
				{
					titolo: 'Esci senza salvare le modifiche',
					testo:'Sono presenti delle modifiche, vuoi uscire senza salvarle?', 
					onConferma:()=>{
						this.resetCorsoInModifica();
						this.isDialogCorsoOpen = false;
						store.commit('nascondiDialogConferma');
					}, 
					onAnnulla:()=>{
						store.commit('nascondiDialogConferma');
					}
				}
			)
		} else {
			this.resetCorsoInModifica();
			this.isDialogCorsoOpen = false;
		}
	  },
	  aggiungiModificaCorso(){
		if(!this.isCorsoValido())
			return;

		if(this.corsoInModifica.id == null){
			axios.post('/corsi', this.corsoInModifica)
				.then(res => {
					this.getCorsiEdizioniENumTecnici()
					this.closeCorsoDialog(false)
					store.commit('mostraSnack', {messaggio: 'Corso inserito con successo', tipo: 'success'})
				})
		} else {
			axios.patch(`/corsi/${this.corsoInModifica.id}`, this.corsoInModifica)
				.then(res => {
					this.getCorsiEdizioniENumTecnici()
					this.closeCorsoDialog(false)
					store.commit('mostraSnack', {messaggio: 'Corso aggiornato con successo', tipo: 'success'})
				})
		}
	  },
	  eliminaCorso(id){
			store.commit('mostraDialogConferma', 
				{
					titolo: 'Elimina corso', 
					testo:`Sicuro di voler eliminare questo corso?`,
					onConferma:()=>{
						axios.delete(`/corsi/${id}`)
							.then(res => {
								this.getCorsiEdizioniENumTecnici()
								store.commit('mostraSnack', {messaggio: 'Corso eliminato con successo', tipo: 'success'})
							})
						store.commit('nascondiDialogConferma')
					}, 
					onAnnulla:()=>{
						store.commit('nascondiDialogConferma')
					}
				}
			)
	  },
	  // ============================================

	  // ================= Edizione =================
	  // Elenco edizioni
	  mostraEdizioniDialog(corso){
		this.isDialogEdizioniOpen = true;
		// this.edizioniCorso = edizioniCorso;
		this.edizioniCorsoIdSelezionato = corso.id;
		this.edizioniCorsoNomeSelezionato = corso.nome;
		this.getEdizioniByCorso();
	  },
	  closeEdizioniDialog(){
		this.isDialogEdizioniOpen = false;
		this.edizioniCorso = [];
		this.edizioniCorsoIdSelezionato = null;
		this.edizioniCorsoNomeSelezionato = null;
		
		this.getCorsiEdizioniENumTecnici() // In ogni caso riscarico tutti i corsi con i valori aggiornati
	  },
	  // ===============
	  isEdizioneCorsoValido(){
		if(this.$refs['formEdizione'].validate())
			return true;
		
		return false;
	  },
	  getEdizioniByCorso(){
		this.isLoadingEdizioni = true;
		this.edizioniCorso = [];
		
		axios.get(`/edizioni_con_num_tecnici_by_corso_id?corso_id=${this.edizioniCorsoIdSelezionato}`)
			.then(res => {
				this.edizioniCorso = res.data;
			})
			.finally(() => {
				this.isLoadingEdizioni = false;
			});
	  },
	  resetEdizioneInModifica(){
			this.edizioneInModifica.id = null;
			this.edizioneInModifica.kajabi_tag = null;
			this.edizioneInModifica.nome = null;
			this.edizioneInModifica.prezzo = null;
			this.edizioneInModifica.scadenza_iscrizione = null;
			this.edizioneInModifica.stato = null;

			this.edizioneModificata = false;

			try {
				this.$refs['formEdizione'].resetValidation()
			} catch (error) {}
	  },
	  openSingolaEdizioneDialog(edizione){
		if(edizione){
			this.edizioneInModifica.id = edizione.id;
			this.edizioneInModifica.kajabi_tag = edizione.kajabi_tag;
			this.edizioneInModifica.nome = edizione.nome;
			this.edizioneInModifica.prezzo = edizione.prezzo;
			this.edizioneInModifica.scadenza_iscrizione = edizione.scadenza_iscrizione;
			this.edizioneInModifica.stato = edizione.stato;
		} else {
			this.resetEdizioneInModifica();
		}

		this.isDialogSingolaEdizioneOpen = true;
	  },
	  closeSingolaEdizioneDialog(daConfermare = true){
		if(this.edizioneModificata && daConfermare){
			store.commit('mostraDialogConferma', 
				{
					titolo: 'Esci senza salvare le modifiche',
					testo:'Sono presenti delle modifiche, vuoi uscire senza salvarle?', 
					onConferma:()=>{
						this.resetEdizioneInModifica();
						this.isDialogSingolaEdizioneOpen = false;
						store.commit('nascondiDialogConferma');
					}, 
					onAnnulla:()=>{
						store.commit('nascondiDialogConferma');
					}
				}
			)
		} else {
			this.resetEdizioneInModifica();
			this.isDialogSingolaEdizioneOpen = false;
		}
	  },
	  aggiungiModificaEdizione(){
		if(!this.isEdizioneCorsoValido())
			return;

		if(this.edizioneInModifica.id == null){
			axios.post('/edizioni_corsi', {...this.edizioneInModifica, corso_id: this.edizioniCorsoIdSelezionato})
				.then(res => {
					this.getEdizioniByCorso()
					this.closeSingolaEdizioneDialog(false)
					store.commit('mostraSnack', {messaggio: 'Edizione inserita con successo', tipo: 'success'})
				});
		} else {
			axios.patch(`/edizioni_corsi/${this.edizioneInModifica.id}`, {...this.edizioneInModifica, corso_id: this.edizioniCorsoIdSelezionato})
				.then(res => {
					this.getEdizioniByCorso()
					this.closeSingolaEdizioneDialog(false)

					store.commit('mostraSnack', {messaggio: 'Edizione aggiornata con successo', tipo: 'success'})
				});
		}
	  },
	  eliminaEdizione(edizione){
		store.commit('mostraDialogConferma', 
			{
				titolo: `Elimina edizione ${edizione.nome}`,
				testo:`Sicuro di voler eliminare l'edizione ${edizione.nome} del corso ${this.edizioniCorsoNomeSelezionato}?`,
				onConferma:()=>{
					axios.delete(`/edizioni_corsi/${edizione.id}`)
						.then(res => {
							this.getEdizioniByCorso();
							store.commit('mostraSnack', {messaggio: 'Edizione eliminata con successo', tipo: 'success'})
						})

					store.commit('nascondiDialogConferma');
				}, 
				onAnnulla:()=>{
					store.commit('nascondiDialogConferma');
				}
			}
		)
	  },
	  // ============================================

    }
  }
</script>


<style lang="scss" scoped>

.tabella-csen {
   background-color: #fff; 
   ::v-deep .v-data-table__wrapper th, .v-data-table-header {
      color: #27316e !important;
      font-size:15px !important;
      background-color: #eef5ff;
      padding: 1rem;
   }
};

.dark {
   ::v-deep .v-data-table__wrapper th {
      color: #c7dcfe !important;
      font-size:15px !important;
      padding: 1rem;
   }
};


</style>